import { BrowserRouter, Routes, Route, Router , Navigate} from "react-router-dom";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import CaseStudyDetails from "./pages/CaseStudyDetails";
import Contact from "./pages/Contact";
import HomeFour from "./pages/HomeFour";
import HomeOne from "./pages/HomeOne";
import HomeThree from "./pages/HomeThree";
import HomeTwo from "./pages/HomeTwo";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ScrollToTop from "react-scroll-to-top";
import HomeFive from "./pages/HomeFive";

import ConnectMessage from "./components/ConnectMessage";
import Login from "./pages/Auth/Login";
import MonEspace from "./pages/MonEspace";
import PartnerShipArea from "./components/PartnerShipArea";
import MemberInscription from "./pages/MemberInscription";
import Register from "./pages/Auth/Register/Register";
import Cookies from 'js-cookie';
import ErrorPage from "./pages/Error/ErrorPage";
import DemanderIdentifiants from "./pages/DemanderIdentifiants";
import ConfirmEmailChange from "./pages/Auth/ConfirmEmailChange";


function App() {


  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();

    
  }, []);

  const isLoggedIn = !!Cookies.get('access_token');

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<HomeTwo />} />
        <Route exact path='/index-2' element={<HomeOne />} />
        <Route exact path='/index-3' element={<HomeThree />} />
        <Route exact path='/index-4' element={<HomeFour />} />
        <Route exact path='/index-5' element={<HomeFive />} />
        <Route exact path='/about' element={<About />} />
        <Route exact path='/blog' element={<Blog />} />
        <Route exact path='/blog-details' element={<BlogDetails />} />
        <Route exact path='/case-study-details' element={<CaseStudyDetails />} />
        <Route exact path='/contact' element={<Contact />} />
        <Route exact path='/service' element={<Service />} />
        <Route exact path='/service-details' element={<ServiceDetails />} />
        <Route exact path='/team' element={<Team />} />
        <Route exact path='/team-details' element={<TeamDetails />} />
        <Route exact path='/connect-message' element={<ConnectMessage />} />
        <Route path="/mon-espace/*" element={isLoggedIn ? <MonEspace /> : <Navigate to="/login" />} />
        
        <Route path="/email/change/confirm" element={<ConfirmEmailChange />} />

        <Route path="/members" element={<PartnerShipArea />}>
          {/* Nested route for Member Inscription */}
          <Route path="inscription" element={<MemberInscription />} />
        </Route>
        {/* <Route exact path='/login' element={<Login />} /> */}

        <Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <Login />} />

        <Route exact path='/register' element={<Register />} />
        <Route exact path='/demander-mes-identifiants' element={<DemanderIdentifiants />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <ScrollToTop smooth color='#246BFD' />
    </BrowserRouter>
  );
}

export default App;
